import React from 'react';

export const LockIcon = () => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Lock body */}
		<rect x='4' y='7' width='8' height='6' rx='1' fill='currentColor' />

		{/* Lock shackle */}
		<path
			d='M6 7V5C6 3.9 6.9 3 8 3C9.1 3 10 3.9 10 5V7'
			stroke='currentColor'
			strokeWidth='1.5'
			fill='none'
			strokeLinecap='round'
		/>

		{/* Keyhole */}
		<circle cx='8' cy='9.5' r='0.8' fill='white' />
	</svg>
);

export const CreditCardIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='16'
		height='16'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		className='lucide lucide-credit-card-icon lucide-credit-card'
	>
		<rect width='20' height='14' x='2' y='5' rx='2' />
		<line x1='2' x2='22' y1='10' y2='10' />
	</svg>
);
